module.exports = __webpack_public_path__ + "img/resource09.faacd3cf.png";